import { render } from "./RoleGuard.vue?vue&type=template&id=5f109cf0&scoped=true"
import script from "./RoleGuard.vue?vue&type=script&lang=js"
export * from "./RoleGuard.vue?vue&type=script&lang=js"

import "./RoleGuard.vue?vue&type=style&index=0&id=5f109cf0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f109cf0"]])

export default __exports__